import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../../app/stores/store';
import './dashboard.css';
import ApproveModal from './../../../app/common/modals/ApproveModal';
import ReportsModal from '../../TableReports/ReportsModal';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { Activity } from '../../../app/models/activity';
import _ from 'lodash';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import Filter from '../../DynamicTable/filter';
import DynamicTableComponentForMetaData from '../../DynamicTable/DynamicTableComponentForMetaData';
import { initialPostFilteredItemDetails } from '../../../app/models/metaDataConfig';
// import LoadingComponent from '../../../app/layout/LoadingComponent';

function DashboardAssetTable() {
  const { activityStore, dashboardStore, userStore, commonStore, metaDataStore } = useStore();
  // const {userReadableDateFormat}=commonStore;
  const { activitiesByDate, loadActivitiesPagination, loadCountAssetTable, HFCloadActivitiesPagination,mepzActivities} =
    activityStore;
  const [pageNumber, setPageNumber] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState<number>(5);
  const [filters, setFilters] = useState<{ column: string; operator: string; value: string }[]>([{ column: '', operator: '', value: '' }]);
  const hfcPageSize = activityStore.HfcSelectedRow || postsPerPage;

  useEffect(() => {
    if (userStore?.user?.customerName === 'Restoration') {
      setPostsPerPage(20);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (dashboardStore.dashboard.setTagTablePageNumber === 1) {
      setPageNumber(dashboardStore.dashboard.setTagTablePageNumber);
    }
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.setTagTablePageNumber]);

  useEffect(() => {
    const pageSize = userStore.user?.customerName === 'Restoration' ? 20 : 5;
    const userId = userStore?.user!.id;
  
    if (commonStore.hfcCustomerChanges) {
      activityStore.HFCloadActivitiesPagination(1, userId, hfcPageSize, []);
      activityStore.HFCDeliveryRequest(1, userId, hfcPageSize, []);
    } else if (userStore.user?.customerName === 'Mepz' || userStore.user?.customerName === 'TNCA') {
      activityStore.MepzLoadActivities(1, postsPerPage, []);
    }
    else{
        commonStore.NFAIReportCustomer 
        ? metaDataStore.PostFilteredItemDetailsHandler(initialPostFilteredItemDetails)
        : activityStore.loadActivitiesPagination(1, userId, pageSize);
    }
  
    if (userStore.user?.customerName === 'LVPCMS') {
      activityStore.searchListItemsLVPMSCount();
    }
    // eslint-disable-next-line
  }, []);
  
  const handleFiltersUpdate = (updatedFilters: { column: string; operator: string; value: string }[]) => {
    setFilters(updatedFilters);
  };

  const userID = userStore.user?.id !== undefined ? userStore.user?.id : '';
  const tableData: Activity[] = [];
  

  activitiesByDate?.forEach((a: any) => {
    // isMaster
    delete a?.isMaster;
    // eslint-disable-next-line
    delete a?.sections_Multiple_From;
    delete a?.sections_From;
    delete a?.synopsis;

    tableData?.push({
      ...a,
      //  movementdate:userReadableDateFormat(a.movementdate),
      //  movement_Time:userReadableDateFormat(a.movement_Time),
      //  maintenance:userReadableDateFormat(a.maintenance),
      //  receivingdate:userReadableDateFormat(a.receivingdate),
      //  status_Time: userReadableDateFormat(a.status_Time),
      //  itemCreatedAt:userReadableDateFormat(a.itemCreatedAt)
    });
  });
  const createOrderFilter = tableData?.filter((x) => x?.isReceiving === false);
  const MainFilter =
    dashboardStore.dashboard.L2CardValueInventory === 'Receiving' &&
    dashboardStore.dashboard.valueForL3Inventory === 'Create Order Receiving'
      ? createOrderFilter
      : tableData;

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,inactive,isgoing,ishost,clearedon';
  const assettable = JSON.parse(JSON.stringify(MainFilter));
  assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  const paginateFunction = (e: number) => {
    const resultArray = Object.entries(dashboardStore.dashboard.searchfilterparams).map(([header, searchValue]) => ({
      header,
      searchValue
    }));
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      commonStore.hfcCustomerChanges ?
      activityStore.HFCsearchListItems(resultArray,
        e,
        hfcPageSize) :
      activityStore.searchListItems(
        dashboardStore.dashboard.searchfilterparams,
        e,
        postsPerPage,
      );
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      const hfcSortDirection =
        dashboardStore.dashboard.orderData === 'Ascending';

      commonStore.hfcCustomerChanges
        ? activityStore.HFCsortListItems(
            dashboardStore.dashboard.orderName,
            hfcSortDirection,
            e,
            hfcPageSize,
          )
        : activityStore.sortListItems(
            dashboardStore.dashboard.orderName,
            dashboardStore.dashboard.orderData,
            e,
            postsPerPage,
          ); 
    } else {
      // console.log(e,userID,postsPerPage,[])
      
      if (commonStore.hfcCustomerChanges) {
        const filterValues = filters.length > 0
          ? filters
              .filter((filter: any) =>
                filter.column.trim() !== '' &&
                filter.operator.trim() !== '' &&
                filter.value.trim() !== ''
              ) 
              .map((filter: any) => ({
                colName: filter.column,
                filterType: filter.operator,
                filterValue: filter.value
              }))
          : [];  
        HFCloadActivitiesPagination(e, userID, hfcPageSize, filterValues);
      } else {
        loadActivitiesPagination(e, userID, postsPerPage);
      }
    }
    dashboardStore.setTagPageNumFunc(e);
    setPageNumber(e);
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };

  const mepzPaginateFunction=(e: any) => {
    activityStore.MepzLoadActivities(e, postsPerPage, []);
  }

  //  if (!loadActivitiesPagination||loadCountAssetTable ) return <div style={{ height: "40vh" }}> <LoadingComponent /> </div> ;
  // const assetTableData=

  return (
    <div>
      {(!loadActivitiesPagination || loadCountAssetTable) && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.DenialModal === true ? (
        <ApproveModal />
      ) : dashboardStore.dashboard.reportsConfiguration === true ? (
        <ReportsModal
          toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
        />
      ) : null}
      {commonStore.filterModeTwo.includes('IDYT1') ? (
        <></>
      ) : (
        <>
        {userStore.user?.customerName === "HFC Media Services" && <Filter onFiltersChange={handleFiltersUpdate}/>}
  
  
        {(userStore?.user?.customerName !== "Mepz" && userStore?.user?.customerName !== "TNCA") ? (
          <DynamicTableComponent
            data={assettable}
            name={'AssetTable'}
            actiontype={''}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            searchFuncData={searchFunction}
            loading={!loadActivitiesPagination || loadCountAssetTable}
            isdisabled={commonStore.filterModeZero.includes('IDYT1')}
          />
         ) : (
          <>
            <Filter onFiltersChange={handleFiltersUpdate} />
            <DynamicTableComponentForMetaData 
              data={mepzActivities} 
              name={'AssetTable'} 
              actiontype={''} 
              pageFunc={mepzPaginateFunction} 
              pageNumData={0} 
              searchFuncData={searchFunction} 
              filters={filters} 
            />
          </>
        )}

        </>
      )}
    </div>
  );
}

export default observer(DashboardAssetTable);
